import Stack from '@mui/material/Stack'

import type { SaveExtraBlockData } from '../../../../core/types/InsightsInstanceSlotData'

import SaveAnExtraCard from '../../../components/SaveAnExtraCard'

import type { BlockProps } from '../../types'

const SaveExtraBlock = ({ payload }: BlockProps<SaveExtraBlockData>) => {
  const { primary_text, secondary_text } = payload.instance_slot_data

  return (
    <Stack sx={{ p: 16 }}>
      <SaveAnExtraCard primaryText={primary_text} secondaryText={secondary_text} />
    </Stack>
  )
}

export default SaveExtraBlock
